import { NEW_BOOKING, ADD_SECTOR, UPDATE_BOOKING_STATUS } from '../graphql/mutations/booking';
import { GET_BOOKING } from '../graphql/queries/getBooking';
import { GET_NEXT_DESTINATION } from '../graphql/queries/getCities';
import { SET_BOOKING_DETAILS, SET_NEXT_DESTINATIONS } from './types';
// import { get } from '../helpers/objectHelper';
import { store } from '../index';
// import { history } from '../components/App';


/**
 * Fetch booking
 * 
 *
 * @param {object} client - Apollo client
 * @param {string} uuid - id of the booking
 * 
 */
export async function FetchBooking(client, uuid){
    try{
       //await store.dispatch({type:BOOKING_DETAILS_LOADING, payload:true});
        const response = await client.query({query:GET_BOOKING, variables:{uuid:uuid}, fetchPolicy:"no-cache"});    
        await store.dispatch({ type:SET_BOOKING_DETAILS, payload:response.data.getBooking});
        //await store.dispatch({type:BOOKING_DETAILS_LOADING, payload:false});
        return response;
    }
   catch({graphQLErrors}){
        if(graphQLErrors.length > 0){
            const hasResponseUrl = (graphQLErrors[0].extensions.response !== undefined) ? graphQLErrors[0].extensions.response.url : "";
            //const hasReponseStatus = (graphQLErrors[0].extensions.response !== undefined) ? graphQLErrors[0].extensions.response.status : "";
            //const hasNotFound = get([0, 'extensions', 'code'], graphQLErrors, "");
            console.error(`${graphQLErrors[0].message} : ${hasResponseUrl}`);
            //if(hasReponseStatus === 500) history.push("/500");
            // if(hasNotFound === "NOT_FOUND") store.dispatch({type:SET_EXPIRED_MODAL, payload:true});
            return graphQLErrors[0].message;
        }
    }
}


/**
 * New booking - Creates a new booking, adds a first sector and fetches next destination 
 * 
 *
 * @param {object} client - Apollo client
 * @param {string} currency - ISO Currency code
 * @param {string} type - Booking type: planner / regular  
 * 
 */
export async function NewBooking(client, currency, type){

    try{
        //1. Update loading state
       // await store.dispatch({type:UPDATE_SECTOR_LOADING, payload:true});

        //2. New booking mutation
        const response = await client.mutate({mutation:NEW_BOOKING, variables:{currency:currency, type:type}});

        await store.dispatch({type:SET_BOOKING_DETAILS, payload:response.data.newBooking});

        //await store.dispatch({type:UPDATE_SECTOR_LOADING, payload:false});

        return response;
        
    }
    catch({graphQLErrors}){
       // await store.dispatch({type:UPDATE_SECTOR_LOADING, payload:false});
        if(graphQLErrors.length > 0){
            const hasResponseUrl = (graphQLErrors[0].extensions.response !== undefined) ? graphQLErrors[0].extensions.response.url : "";
            //const hasReponseStatus = (graphQLErrors[0].extensions.response !== undefined) ? graphQLErrors[0].extensions.response.status : "";
            console.error(`${graphQLErrors[0].message} : ${hasResponseUrl}`);
            //if(hasReponseStatus === 500) history.push("/500");
            return graphQLErrors[0].message;
        }
    }    
}


/**
 * Add sector and fetches next destination 
 * 
 *
 * @param {object} client - Apollo client
 * @param {string} bookingId - id of the booking created in the "NewBooking"
 * @param {string} tourId - CYO/CYU for for products the Product/tour id IT1 etc,
 * @param {string} type - Sector type: start, city, product
 * @param {string} to - destination city / for start sector the start city
 * @param {int} nights - number of nights for a stop, for start sector defaults to 0, but it can be set to any value, for city stops number of nights is mandatory
 * @param {string} date - for start sector arrival date in the start city
 * @param {string} name - name of the sector
 *
 */
 export async function AddSector(client, bookingId, tourId, type, to, nights, date, name){
    try{
        //1. Update loading state
       //await store.dispatch({type:UPDATE_SECTOR_LOADING, payload:true});

        //2. Add a new sector / fetch next destinations / update loading state
        const response = await client.mutate({mutation:ADD_SECTOR, variables:{bookingId:bookingId, tourId:tourId, type:type, to:to, date:date, nights:nights, name:name}});
        await store.dispatch({type:SET_BOOKING_DETAILS, payload:response.data.addSector});

        const getDestination = await client.query({query:GET_NEXT_DESTINATION, variables:{bookingId:bookingId, maxWait:30}, fetchPolicy:"no-cache"});
        await store.dispatch({ type: SET_NEXT_DESTINATIONS, payload:getDestination.data.next});

        //await store.dispatch({type:UPDATE_SECTOR_LOADING, payload:false});

        return getDestination;
    }
    catch({graphQLErrors}){
       // await store.dispatch({type:UPDATE_SECTOR_LOADING, payload:false});
        if(graphQLErrors.length > 0){
            const hasResponseUrl = (graphQLErrors[0].extensions.response !== undefined) ? graphQLErrors[0].extensions.response.url : "";
            //const hasReponseStatus = (graphQLErrors[0].extensions.response !== undefined) ? graphQLErrors[0].extensions.response.status : "";
            console.error(`${graphQLErrors[0].message} : ${hasResponseUrl}`);
            //if(hasReponseStatus === 500) history.push("/500");
            return graphQLErrors[0].message;
        }
    } 
 }



/**
 * Update the status of the booking
 *
 * @param {object} client - Apollo client
 * @param {string} bookingId - Id of the booking created
 * @param {string} status - Status of the bookinh
 */
export async function UpdateBookingStatus(client, bookingId, status){
    try{
        //update booking status
        const response = await client.mutate({mutation: UPDATE_BOOKING_STATUS, variables:{bookingId:bookingId, status:status}});
        return response;
    }
    catch({graphQLErrors}){
        if(graphQLErrors.length > 0){
            const hasResponseUrl = (graphQLErrors[0].extensions.response !== undefined) ? graphQLErrors[0].extensions.response.url : "";
            //const hasReponseStatus = (graphQLErrors[0].extensions.response !== undefined) ? graphQLErrors[0].extensions.response.status : "";
            console.error(`${graphQLErrors[0].message} : ${hasResponseUrl}`);
            // if(hasReponseStatus === 500) history.push("/500");
            return graphQLErrors[0].message;
        }    
    }
}